import { useState, useEffect, useContext } from "react";
import { IoArrowDownOutline, IoArrowUpOutline } from "react-icons/io5";
import { MdOutlineCurrencyExchange } from "react-icons/md";
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { Link, NavLink, Navigate } from "react-router-dom";
import { pricePublicContext } from "../../context/PublicContext/PricePublicContext/PricePublicContext";

const ListUi = ({ roleName, _item, userInfo }) => {
  // استفاده از context
  const {
    statePrice,
    setStatePrice,
    stateWeight,
    setStateWeight,
    stateTotal,
    setStateTotal,
    description,
    setDescription,
    transactionId,
    setTransactionId,
    product_name,
    setProduct_name,
    customeruser,
    setCustomeruser,
    bos,
    setBos,
    is_orderi,
    setIs_orderi,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    resultModal,
    setResultModal,
    orderModal,
    setOrderModal,
    data,
    setData,
    type,
    setType,
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
  } = useContext(pricePublicContext);

  // State for transaction modal
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [transactionType, setTransactionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle price click (buy/sell)
  const handlePriceClick = (type) => {
    setTransactionType(type);
    setStatePrice(_item[`${type}_price`]);
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setShowTransactionModal(true);
    setResultModal(false);
    setOrderModal(true);
  };

  // Calculate total
  const calculateTotal = (price, weight) => {
    if (price && weight) {
      setStateTotal(parseInt(price) * parseInt(weight));
    } else {
      setStateTotal("");
    }
  };

  // تابع برای حذف "بدون حباب" از اسم محصول
  const removeWithoutBubble = (productName) => {
    if (!productName) return "";

    return productName
      .replace(/بدون حباب/g, "عادی")
      .replace(/بدونحباب/g, "عادی")
      .replace(/بدون_حباب/g, "عادی")
      .trim();
  };

  // Handle form submission
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    // آماده کردن دیتا
    const payload = {
      product_name: _item.name,
      customeruser: userInfo[0]?.id,
      bos: transactionType === "buy" ? "B" : "S",
      is_orderi:
        transactionType === "buy"
          ? _item.buy_price !== statePrice
          : _item.sell_price !== statePrice,
      price: statePrice,
      volume: stateWeight,
      amount: stateTotal,
      description: description,
    };

    try {
      // نیازی به setTransactionId در اینجا نیست چون در Context ست می‌شود
      await handlePostTransaction(payload);

      // فقط مودال تراکنش را می‌بندیم (مودال نتیجه توسط Context باز می‌شود)
      setShowTransactionModal(false);
    } catch (error) {
      // خطا قبلاً در handlePostTransaction مدیریت شده
      console.error("Transaction failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  // Reset form
  const resetForm = () => {
    setStatePrice("");
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setShowTransactionModal(false);
    setResultModal(false);
    setTransactionType("");
    setTransactionId(null);
  };

  return (
    <>
      {/* Main Table Row */}
      <tr className="hover:bg-gray-50">
        {/* Product Name */}
        <td className="py-4">
          <div className="flex items-center justify-center font-medium">
            {removeWithoutBubble(_item.name)}
          </div>
        </td>

        {/* Buy Price */}
        <td className="py-4">
          <div className="flex flex-col items-center space-y-2">
            <div className="text-green-600 flex items-center">
              <div
                onClick={() => handlePriceClick("buy")}
                className="flex items-center cursor-pointer"
              >
                {_item.buy_price === -1 ? (
                  "-"
                ) : (
                  <>
                    {_item.buy_format === "+" && (
                      <IoArrowUpOutline className="ml-1" />
                    )}
                    {_item.buy_format === "-" && <IoArrowDownOutline />}

                    <PersianNumber
                      value={_item.buy_price}
                      thousandSeparator=","
                    />

                    <span className="text-xs text-gray-500 mr-1">تومان</span>
                  </>
                )}
              </div>
            </div>
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeBuyClosePriceProduct(
                    _item.id,
                    !_item.is_buy_closed,
                    _item.periority,
                    _item.is_sell_closed,
                    _item.is_market_close,
                  )
                }
                className={`text-sm ${
                  _item.is_buy_closed ? "text-red-600" : "text-green-600"
                }`}
              >
                {_item.is_buy_closed ? "قیمت خرید بسته" : "قیمت خرید باز"}
              </button>
            )}
          </div>
        </td>

        {/* Sell Price */}
        <td className="py-4">
          <div className="flex flex-col justify-center items-center space-y-2">
            <div className="text-red-600 flex items-center">
              <div
                onClick={() => handlePriceClick("sell")}
                className="flex items-center cursor-pointer"
              >
                {_item.sell_price === -1 ? (
                  "-"
                ) : (
                  <>
                    {_item.sell_format === "+" && (
                      <IoArrowUpOutline className="ml-1" />
                    )}
                    {_item.sell_format === "-" && <IoArrowDownOutline />}
                    <PersianNumber
                      value={_item.sell_price}
                      thousandSeparator=","
                    />
                    {roleName !== "ADMIN" && (
                      <span className="text-xs text-gray-500 mr-1">تومان</span>
                    )}
                  </>
                )}
              </div>
            </div>
            {roleName === "ADMIN" && (
              <button
                onClick={() =>
                  handleChangeSellClosePriceProduct(
                    _item.id,
                    !_item.is_sell_closed,
                    _item.periority,
                    _item.is_buy_closed,
                    _item.is_market_close,
                  )
                }
                className={`text-sm ${
                  _item.is_sell_closed ? "text-red-600" : "text-green-600"
                }`}
              >
                {_item.is_sell_closed ? "قیمت فروش بسته" : "قیمت فروش باز"}
              </button>
            )}
          </div>
        </td>

        {/* Last Update */}
        <td className="py-3">
          <div className="flex justify-center text-gray-600">
            {_item.last_update_time_ago}
          </div>
        </td>
      </tr>

      {/* Transaction Modal */}
      {showTransactionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="w-full max-w-md">
            {!resultModal ? (
              // Transaction Form
              <div className="w-full bg-gray-300 relative rounded-lg">
                {/* Title */}
                <div className="flex justify-center items-center w-full p-6 bg-gray-300 rounded-t-lg">
                  <p className="text-base font-medium text-black">
                    سفارش{" "}
                    <span
                      className={`${
                        transactionType === "buy"
                          ? "text-green-700"
                          : "text-red-700"
                      }`}
                    >
                      {transactionType === "buy" ? "خرید" : "فروش"}
                    </span>{" "}
                    برای " {removeWithoutBubble(_item?.name)} "
                  </p>
                </div>

                {/* Confirmation Summary */}
                <div className="grid grid-cols-2 gap-y-4 justify-items-center pb-4 items-center w-full bg-gray-300 text-gray-900 text-base">
                  {/* Price */}
                  <span className="flex flex-col items-center space-y-1">
                    <span>{_item.tag === "S" ? "قیمت" : "مظنه"} </span>
                    <span>
                      {statePrice ? (
                        <PersianNumber
                          value={statePrice}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Weight */}
                  <span className="flex flex-col items-center space-y-1">
                    <span>{_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}</span>
                    <span>
                      {stateWeight ? (
                        <PersianNumber
                          value={stateWeight}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Total */}
                  <span className="flex flex-col items-center">
                    <span>جمع کل</span>
                    <span>
                      {stateTotal ? (
                        <PersianNumber
                          value={stateTotal}
                          thousandSeparator=","
                        />
                      ) : (
                        "-"
                      )}
                    </span>
                  </span>

                  {/* Description */}
                  <span className="flex flex-col items-center w-32 overflow-hidden text-ellipsis whitespace-nowrap">
                    <span>توضیحات</span>
                    <span>{description || "-"}</span>
                  </span>
                </div>
                <div className="border-b-2 border-boxColor" />

                {/* Form Inputs */}
                <div className="w-full px-6 py-5 bg-gray-300">
                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col w-full">
                      {/* Order Icon */}
                      {(transactionType === "buy" &&
                        _item.buy_price !== statePrice) ||
                      (transactionType === "sell" &&
                        _item.sell_price !== statePrice) ? (
                        <span className="absolute px-2 py-1 rounded-full top-2 left-1 flex items-center text-slate-300">
                          <div className="group flex relative">
                            <MdOutlineCurrencyExchange
                              size={18}
                              className="animate-spin-slow"
                            />
                            <span className="group-hover:opacity-0 transition-opacity px-1 text-sm text-slate-300 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto">
                              اردری
                            </span>
                          </div>
                        </span>
                      ) : null}

                      {/* Input Fields */}
                      <div className="space-y-4">
                        {/* Price */}
                        <div>
                          <label
                            htmlFor="price"
                            className="block mb-2 text-sm font-medium text-black"
                          >
                            {_item.tag === "S" ? "قیمت" : "مظنه"}
                          </label>
                          <input
                            type="text"
                            id="price"
                            autoComplete="off"
                            value={
                              statePrice === -1 ? "" : addCommas(statePrice)
                            }
                            onChange={(e) => handlePriceChange(_item, e)}
                            className={`p-2 w-full bg-gray-300 border-2 border-slate-600 rounded-md focus:outline-none text-slate-800 ${
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>

                        {/* Weight */}
                        <div>
                          <label
                            htmlFor="weight"
                            className="block mb-2 text-sm font-medium text-black"
                          >
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            name="weight"
                            value={stateWeight}
                            onChange={(e) => handleWeightChange(_item, e)}
                            className={`p-2 w-full bg-gray-300 border-2 border-slate-600 rounded-md focus:outline-none text-slate-800 ${
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>

                        {/* Total */}
                        <div>
                          <label
                            htmlFor="total"
                            className="block mb-2 text-sm font-medium text-black"
                          >
                            جمع کل
                          </label>
                          <input
                            type="text"
                            id="total"
                            autoComplete="off"
                            value={addCommas(stateTotal)}
                            onChange={(e) => handleTotalChange(_item, e)}
                            className={`p-2 w-full bg-gray-300 border-2 border-slate-600 rounded-md focus:outline-none text-slate-800 ${
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>

                        {/* Description */}
                        <div>
                          <label
                            htmlFor="description"
                            className="block mb-2 text-sm font-medium text-black"
                          >
                            توضیحات
                          </label>
                          <input
                            type="text"
                            id="description"
                            autoComplete="off"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className={`p-2 w-full bg-gray-300 border-2 border-slate-600 rounded-md focus:outline-none text-slate-800 ${
                              transactionType === "buy"
                                ? "focus:border-green-600 focus:text-green-600"
                                : "focus:border-red-600 focus:text-red-600"
                            }`}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      {setProduct_name(_item.name)}
                      {setCustomeruser(userInfo[0]?.id)}
                      {setBos(transactionType === "buy" ? "B" : "S")}
                      {setIs_orderi(
                        transactionType === "buy"
                          ? _item.buy_price !== statePrice
                          : _item.sell_price !== statePrice,
                      )}
                    </div>
                    {/* Buttons */}
                    <div className="flex justify-center items-center w-full mt-5">
                      <button
                        type="button"
                        onClick={resetForm}
                        className="text-slate-700 text-base tracking-wider mx-4"
                        disabled={isSubmitting}
                      >
                        لغو
                      </button>
                      <button
                        type="submit"
                        className={`${
                          transactionType === "buy"
                            ? "bg-green-500 hover:bg-green-700"
                            : "bg-red-500 hover:bg-red-700"
                        } rounded-full px-3 py-0.5 mx-2 tracking-wider text-base text-black transition-all duration-100`}
                        disabled={isSubmitting}
                      >
                        {isSubmitting
                          ? "در حال ثبت..."
                          : transactionType === "buy"
                            ? "خرید"
                            : "فروش"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              // Result Modal
              <div className="w-full px-6 py-5 bg-gray-300 rounded-lg">
                {transactionId ? (
                  // Success - نمایش موفقیت
                  <div className="flex flex-col items-center space-y-5">
                    <div className="text-center">
                      <p
                        className={`${
                          transactionType === "buy"
                            ? "text-green-600"
                            : "text-red-600"
                        } font-bold text-lg`}
                      >
                        تراکنش با موفقیت ثبت شد
                      </p>
                      <p className="text-slate-700 mt-2">
                        شماره تراکنش: #{transactionId}
                      </p>
                    </div>
                    <div className="flex space-x-4">
                      <NavLink to="/Public/Live-Transactions">
                        <button
                          onClick={resetForm}
                          className="bg-yellow-500 hover:bg-yellow-600 text-slate-700 rounded-full px-4 py-1 transition-colors"
                        >
                          معاملات جاری
                        </button>
                      </NavLink>
                      <button
                        onClick={resetForm}
                        className="bg-green-500 hover:bg-green-600 text-white rounded-full px-4 py-1 transition-colors"
                      >
                        بستن
                      </button>
                    </div>
                  </div>
                ) : (
                  // Error - نمایش خطا
                  <div className="flex flex-col items-center space-y-5">
                    <p className="text-red-600 font-bold text-lg text-center">
                      خطا در ثبت تراکنش!
                    </p>
                    <p className="text-slate-700 text-center">
                      لطفاً دوباره تلاش کنید.
                    </p>
                    <button
                      onClick={resetForm}
                      className="bg-red-500 hover:bg-red-700 text-white rounded-full px-4 py-1 transition-colors"
                    >
                      بستن
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ListUi;
